import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Contract from "slotworks/utils/contract";
import { parallel } from "slotworks/utils/race-utils";

export function DisplaySymbolsCommand(symbols: SymbolComponent[], time: number = 800): Contract<void> {
    const winningSymbolMethods: Array<() => Contract<void>> = [];

    for (let symbol of symbols) {

        symbol.static();

        winningSymbolMethods.push(() => {
            return symbol.display();
        });
    }

    if(winningSymbolMethods.length) {
        winningSymbolMethods.push(() => Contract.getTimeoutContract(time));
    }

    return parallel(winningSymbolMethods);
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/symbols/display-symbols-command.ts